// extracted by mini-css-extract-plugin
export var content = "_r5-1";
export var fullScreen = "_r5-0";